export function isUrlVideo(url?: string): boolean {
  if (!url) return false;
  const videoExtensions = [".mp4", ".webm", ".mov"];
  return !!videoExtensions.find((extension) => url.includes(extension));
}

/**
 * Helper for determining the file type of an `animation_url` on an NFT
 */
export function getOnlyVideoSrcFromUrl(url?: string): string | undefined {
  if (isUrlVideo(url)) {
    return url;
  }
  return undefined;
}
